import { IRoleInitialState } from "../../../types/master/roleInterface";
import { RoleActionTypes, RoleActions } from "../../actionTypes/master/roleActionTypes";


const initialState: IRoleInitialState = {
  roleList: [],
  roleData: {
    id: 0,
    role_name: "",
    slug: "",
    department_id: 0,
    created_by: 0,
  },
  roleListPageCount: 0,
  departmentId: 0
};

export default function roleReducer(state = initialState, action: RoleActionTypes): IRoleInitialState {
  switch (action.type) {

    case RoleActions.SET_ROLE_LIST:
      return {
        ...state,
        roleList: action.payload,
      };

    case RoleActions.SET_ROLE_LIST_PAGE_COUNT:
      return {
        ...state,
        roleListPageCount: action.payload
      };

    case RoleActions.SET_ROLE_DATA_BY_ID:
      return {
        ...state,
        roleData: action.payload,
      };

    case RoleActions.SET_DEPARTMENT_ID:
      return {
        ...state,
        departmentId: action.payload,
      };

    default:
      return state;
  }
}